@if (shouldShow()) {
<div class="global-upload-popup" [class.minimized]="isMinimized()">
    <div class="popup-header" (click)="toggleMinimize()">
        <div class="header-info">
            <i class="pi pi-cloud-upload"></i>
            <span>{{ 'VIDEOS.UPLOAD_PROGRESS' | translate }}: {{ uploadTasks().size }} {{ 'VIDEOS.VIDEOS_LABEL' | translate }}</span>
        </div>
        <div class="header-actions">
            <p-button 
                [icon]="isMinimized() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
                [text]="true" 
                size="small"
                styleClass="p-0 text-white"
                (onClick)="$event.stopPropagation(); toggleMinimize()">
            </p-button>
        </div>
    </div>

    <div class="popup-content">
        <div class="upload-list" *ngIf="!isMinimized()">
            @for (task of uploadTasks() | keyvalue; track task.key) {
                <div class="upload-item" (click)="navigateToSection(task.value)">
                    <div class="item-main">
                        <div class="item-info">
                            <span class="title" [title]="task.value.videoTitle">{{ task.value.videoTitle }}</span>
                            <span class="percentage">{{ task.value.progress }}%</span>
                        </div>
                        <div class="progress-bar-container">
                            <div class="progress-fill" [style.width]="task.value.progress + '%'"></div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
}
